import "leaflet/dist/leaflet.css";

export interface MapStylesType {
  streets: string;
  satellite: string;
}

export const MapStylesTest: MapStylesType = {
  streets: "streets-v11",
  satellite: "satellite-v9",
};

export const MapStylesProd: MapStylesType = {
  streets: "roadmap",
  satellite: "satellite",
};
